import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-alt",
  "use": "close-alt-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol aria-hidden=\"true\" class=\"css-6q0nyr-Svg\" viewBox=\"0 0 20 20\" id=\"close-alt\"><path d=\"M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol